import tableAppTagsWhiteLabel from './tableAppTagsWhiteLabel';

export default {
  title: 'White Label Tags Management',
  attributeName: 'appTags',
  getURL: 'appId/appTagsPlay',
  createURL: 'appId/appTagsPlay',
  updateURL: 'appId/appTagsPlay',
  removeURL: 'appId/appTagsPlay',
  sessionParams: ['appId'],
  canCreate: true,
  idAttribute: 'id',
  itemId: 'id',
  itemName: 'name',
  removeNameField:'name',
  removeText:'You are about to remove the tag with name ##name##.',
  tableConfig: tableAppTagsWhiteLabel,
  autoUpdate: true,
  noArea: true,
  goBack: true,
};
